<!-- 圆环图 -->
<template>
    <div ref="main" class="sad" style="width: 100%;height: 100%"></div>
</template>
<script setup>
import {ref, onMounted, watch} from "vue";
//  按需引入 echarts
import * as echarts from "echarts";

const main = ref() // 使用ref创建虚拟DOM引用，使用时用main.value
const props = defineProps({
    legend: {
        type: Object,
        default: {
            show: false
        }
    },
    // 换行清况
    title: {
        type: [Array, String],
        default: ''
    },
    // 依次展示的颜色
    color: {
        type: Array,
        default: []
    },
    data: {
        type: Array,
        default: []
    },
    radius: {
        type: [Array, String],
        default: ['55%', '70%']
    },
    yCenter: {
        type: Boolean,
        default: false
    }
})
watch(props, () => {
    init()
})

onMounted(
    () => {
        init()
    }
)

function init() {
    // echarts.init(main.value)
    let myChart = echarts.init(main.value);
    let option = {
        title: {
            text: Array.isArray(props.title) ? props.title.join('\n') : props.title, // 圆环图标题
            x: 'center', // 标题水平居中
            y: props.yCenter ? 'center' : 'top',
            textStyle: {
                color: '#333',
                fontSize: 14,
                fontWeight: 'bold',
                lineHeight: 20
            }
        },
        tooltip: {
            show: false
        },
        legend: {
            show: false,
            ...props.legend,
            formatter: function (name) {
                let item = props.data.find(item => item.name === name);
                let total = 0,percentage=0
                if(item) {
                     total = props.data.reduce((sum, item) => sum + item.value, 0);
                     percentage = ((item.value / total) * 100).toFixed(2) + '%';
                }
                return item ? '{nameStyle|' + name + '}' + '       ' + '{percentageStyle|' + percentage + '}' : '';
            },
            textStyle: {
                rich: {
                    nameStyle: {
                        color: '#666666',
                        fontSize: 12,
                    },
                    percentageStyle: {
                        color: '#333333',
                        fontSize: 12,
                        paddingLeft:10,
                        fontWeight:'bold'
                    }
                }
            },
        },
        series: [
            {
                name: 'Access From',
                type: 'pie',
                radius: props.radius,
                color: props.color,
                label: {
                    show: true,
                    formatter: (params) => {
                        return [
                            '{a|' + params.percent + '%}',
                            '{b|' + params.name + '}'
                        ].join('\n');
                    },
                    lineHeight: 16,
                    rich: {
                        a: {
                            color: '#333',
                            fontWeight: 'bold',
                            fontSize: 12,
                        },
                        b: {
                            color: '#666',
                            fontSize: 12,
                        }
                    }
                },
                data: props.data
            }
        ]
    };
    myChart.setOption(option)
}

</script>
